import { render, staticRenderFns } from "./CreditInvoiceView.vue?vue&type=template&id=5d0c2387&"
import script from "./CreditInvoiceView.vue?vue&type=script&lang=js&"
export * from "./CreditInvoiceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports